<template>
  <div class="rj-Collapse">
    <div class="rj-Collapse__header" @click="toggle">
      <div class="rj-Collapse__headerText">
        <slot name="header" />
      </div>
      <div class="rj-Collapse__Icon" :class="{'is-open':reOpen}">
        <span>{{ reOpen?'收起':'展开' }}</span> <i class="el-icon-arrow-down" />
      </div>
    </div>
    <el-collapse-transition>
      <div v-show="reOpen" class="rj-Collapse__body">
        <slot />
      </div>
    </el-collapse-transition>
  </div>
</template>
<script type="es6">
export default {
  data () {
    return {
      reOpen: false
    };
  },
  model: {
    prop: open,
    event: 'change'
  },
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  computed: {},
  methods: {
    toggle () {
      this.reOpen = !this.reOpen;
      this.$emit('change', this.reOpen);
    }
  },
  mounted () {
    this.reOpen = this.open;
    this.$emit('change', this.reOpen);
  }
};
</script>
<style lang="scss">
  @import "../../style/var";
  @include namespace(Collapse){
    width: 100%;
    border: $CollapseBorder;
    margin-bottom: 15px;
    @include state(header){
      position: relative;
      padding: $CollapseHeaderPadding;
      background: $CollapseHeaderBG;
      display: flex;
      cursor: pointer;
    }
    @include state(headerText) {
      // flex: 1;
      width:-webkit-calc(100% - 100px);
      width:-moz-calc(100% - 100px);
      width:calc(100% - 100px);
    }
    @include state(Icon) {
      width:80px;
      text-align: center;
      cursor: pointer;
      color: $--color-primary;
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      i{
        margin-left: 6px;
        transition: all .3s  ease-in-out;
      }
      @include position(open){
        i{
          transform:rotate(180deg);
        }
      }
    }
  }
</style>
